import React, {
  createRef,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getComma } from '../../utils/getComma'

// images
import IconDown from '../../assets/image/arrow/ic-down.svg'

// components
import { Selector } from '../../components'
import Button from '../../components/atom/button/Button'
import ToggleBtn from '../../components/atom/toggleBtn/ToggleBtn'
import ChkBox from '../atom/checkBox/ChkBox'
import DropDown from '../dropdown/DropDown'
import Empty from '../../pages/reviewList/components/Empty'
import Loading from '../../components/atom/loading/Loading'

const OptionMenu = ({
  dataItems,
  dataItem,
  chkNon,
  checkedItems,
  setCheckedItems,
  saleItems,
  setSaleItems,
  setNonSaleItems,
  postOptions,
  isInit,
  getLoading,
}) => {
  // 탭(메뉴, 옵션)
  const [selectTabIdx, setSelectTabIdx] = useState(1)
  const navigate = useNavigate()
  // 데이터 배열 담는 곳
  const [optionList, setOptionList] = useState([])
  const [combinedOptionList, setCombinedOptionList] = useState([])

  // 옵션메뉴(연결된 메인메뉴)
  const containerRef = Array.from({
    length: dataItem.length,
  }).map(() => createRef())

  // 드롭다운 유무 체크
  const [isOverflowing, setIsOverflowing] = useState([])

  // 숨김 처리시(hide)
  const hideRefs = Array.from({ length: dataItem.length }).map(() =>
    createRef(),
  )

  const handleTab = (flag) => {
    // setOrderIncludeCancel(true)
    setSelectTabIdx(flag)

    if (flag === 0) {
      navigate('/itemList')
    }
    if (flag === 1) {
      navigate('/optionList')
    }
  }

  // 정렬 dropdown
  const sortOption = ['등록순', '오름차순', '내림차순']
  const [sortOptionStatus, setSortOptionStatus] = useState(sortOption[0])

  // 판매중 버튼 클릭
  const handleSaleClick = () => {
    if (checkedItems.length === 0) {
      alert('메뉴를 선택해주세요.')
      return
    }

    const updatedSaleItems = [
      ...new Set([
        ...saleItems,
        ...checkedItems.filter((item) => {
          // combinedOptionList saleYn이 'Y'가 아닌 항목만 필터링
          const combinedItem = combinedOptionList.find(
            (combined) => combined.goodsCode === item,
          )
          return combinedItem && combinedItem.saleYn !== 'Y'
        }),
      ]),
    ]

    setSaleItems(updatedSaleItems)
    postOptions(updatedSaleItems, [])
  }

  // 숨김 버튼 클릭
  const handleNonSaleClick = () => {
    if (checkedItems.length === 0) {
      alert('메뉴를 선택해주세요.')
      return
    }

    const updatedNonSaleItems = [
      ...new Set([
        ...saleItems,
        ...checkedItems.filter((item) => {
          // combinedOptionList saleYn이 'N'가 아닌 항목만 필터링
          const combinedItem = combinedOptionList.find(
            (combined) => combined.goodsCode === item,
          )
          return combinedItem && combinedItem.saleYn !== 'N'
        }),
      ]),
    ]

    setNonSaleItems(updatedNonSaleItems)
    postOptions([], updatedNonSaleItems)
  }

  // 전체 체크박스 핸들러
  const handleAllChecked = (checked) => {
    // console.log('전체 선택')
    // console.log('checkedItems 전체선택', checkedItems)
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = []
      optionList.forEach((item) => idArray.push(item.goodsCode))
      setCheckedItems(idArray)
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckedItems([])
    }
  }

  // 개별 체크박스 핸들러
  const handleCheckedItem = (checked, chk) => {
    if (checked) {
      setCheckedItems((prev) => [...prev, chk])
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== chk))
    }
  }

  // 테이블 toggle 개별 스위치 핸들러
  const handleSellChange = (item, newValue, index) => {
    item.saleYn = newValue
    const itemRef = hideRefs[index].current
    const itemRef2 = containerRef[index].current

    console.log('itemRef', itemRef)
    console.log('itemRef2', itemRef2)

    // 숨김
    if (item.saleYn === 'N') {
      setNonSaleItems((prevNonSaleItems) => {
        console.log('setNonSaleItems 숨김 : ', prevNonSaleItems)
        console.log('숨김 item.goodsCode : ', item.goodsCode)
        const newNonSaleItems = [item.goodsCode]
        itemRef.classList.add('hide')
        return newNonSaleItems
      })
    }
    // 판매중
    if (item.saleYn === 'Y') {
      setSaleItems((prevSaleItems) => {
        console.log('setSaleItems 판매중 : ', prevSaleItems)
        console.log('판매중 item.goodsCode : ', item.goodsCode)
        const newSaleItems = [item.goodsCode]

        itemRef.classList.remove('hide')
        return newSaleItems
      })
    }
  }

  useEffect(() => {
    let sortedItemList = dataItem.slice() // 기존 배열 복사
    if (sortOptionStatus === '오름차순') {
      sortedItemList.sort((a, b) => {
        return a.goodsName.localeCompare(b.goodsName)
      })
    } else if (sortOptionStatus === '내림차순') {
      sortedItemList.sort((a, b) => {
        return b.goodsName.localeCompare(a.goodsName)
      })
    }

    // 정렬된 리스트를 상태로 설정
    if (sortOptionStatus === '등록순') {
      setOptionList(dataItem)
    } else {
      setOptionList(sortedItemList)
    }
  }, [dataItem, sortOptionStatus])

  useEffect(() => {
    if (optionList) {
      const menuItems = optionList.filter((item) => item.saleYn === 'Y')
      const hiddenItems = optionList.filter((item) => item.saleYn === 'N')
      const combinedItems = [...menuItems, ...hiddenItems]

      setCombinedOptionList(combinedItems)
    }
    if (chkNon) {
      setCheckedItems([])
    }

    // console.log('item.itemlist', optionList?.itemlist)
  }, [optionList])

  const [isMoreViewList, setIsMoreViewList] = useState([])

  // 옵션메뉴 더보기 버튼
  const onClickMoreViewButton = (str, goodsId) => {
    // setLimit(str.join(', ').length)
    // setIsMoreView(!isMoreView)
    setIsMoreViewList((prevExpanded) => {
      if (prevExpanded.includes(goodsId)) {
        return prevExpanded.filter((id) => id !== goodsId)
      } else {
        return [...prevExpanded, goodsId]
      }
    })
  }

  // 브라우저 화면 조절시 실행되는 함수(드롭다운 체크)
  const handleResize = () => {
    setIsOverflowing((prevIsOverflowing) => {
      const newIsOverflowing = [...prevIsOverflowing]

      combinedOptionList?.forEach((item, index) => {
        const contentWidth = containerRef[index]?.current?.scrollWidth
        const containerWidth = containerRef[index]?.current?.clientWidth

        newIsOverflowing[index] = contentWidth > containerWidth
      })

      return newIsOverflowing
    })

    // console.log('isOverflowing ', isOverflowing)
  }

  // 브라우저 resize 함수실행
  useEffect(() => {
    if (containerRef) {
      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [containerRef])

  // 초기 렌더링 시 handleResize 실행
  useEffect(() => {
    handleResize()
  }, [combinedOptionList])

  return (
    <>
      {getLoading ? (
        <Loading />
      ) : (
        <>
          <TableHeaderBox>
            <Selector
              leftText={'메뉴관리'}
              rightText={'옵션관리'}
              selectedIdx={selectTabIdx}
              handleTab={handleTab}
            />
            <div className="tableRight">
              <DropDown
                className="sortDropdown"
                defaultOption={'등록순'}
                options={sortOption}
                setOption={setSortOptionStatus}
                value={sortOptionStatus}
              />
              <Button
                type="button"
                width={69 + 'px'}
                height={28 + 'px'}
                radius={4 + 'px'}
                onClick={handleSaleClick}
              >
                판매중
              </Button>
              <Button
                type="button"
                width={69 + 'px'}
                height={28 + 'px'}
                radius={4 + 'px'}
                onClick={handleNonSaleClick}
              >
                숨김
              </Button>
            </div>
          </TableHeaderBox>
          {dataItem.length === 0 ? (
            <Empty pointTxt={'조회된 옵션'} txt={'이 없습니다.'} />
          ) : (
            <>
              <TableMenu>
                <MenuTh>
                  <div className="custom-checkbox">
                    <ChkBox
                      type="checkbox"
                      id={'allChk'}
                      checked={
                        checkedItems.length === optionList?.length
                          ? true
                          : false
                      }
                      onChange={(e) => handleAllChecked(e.target.checked)}
                    />
                  </div>
                  <div>옵션명</div>
                  <div>연결된 메인메뉴</div>
                  <div>가격</div>
                  <div>판매상태</div>
                </MenuTh>
                {combinedOptionList?.map((item, i) => {
                  const itemClassName =
                    item.saleYn === 'N' ? 'MenuItem hide' : 'MenuItem'

                  const isItemExpanded = isMoreViewList.includes(item.goodsId)

                  return (
                    <MenuItem
                      key={i}
                      ref={hideRefs[i]}
                      className={itemClassName}
                    >
                      <ChkBox
                        id={item.goodsCode}
                        checked={
                          checkedItems.includes(item.goodsCode) ? true : false
                        }
                        value={item.goodsCode}
                        onChange={(e) =>
                          handleCheckedItem(e.target.checked, item.goodsCode)
                        }
                      />
                      <p className="optionTxt">{item.goodsName}</p>
                      <div className="menuTitBox">
                        <button
                          className="moreBtn"
                          type="button"
                          onClick={() =>
                            onClickMoreViewButton(item.itemlist, item.goodsId)
                          }
                        >
                          <p className="menuTxt" ref={containerRef[i]}>
                            {item?.itemlist.join('/ ')}
                            {/* {handleResize(item?.itemlist, i).string.join(', ')} */}
                          </p>
                          {isOverflowing[i] && (
                            <ArrowBox isActive={isItemExpanded}>
                              <img src={IconDown} alt="아래화살표" />
                            </ArrowBox>
                          )}
                        </button>
                      </div>
                      <p className="menuPrice">
                        {getComma(item?.supplyPrice)}원
                      </p>
                      <ToggleBtn
                        yn={item.saleYn}
                        setYn={(newValue) => {
                          handleSellChange(item, newValue, i)
                        }}
                        id={toString(item.goodsCode) + i}
                        width={79}
                      />
                      {isItemExpanded && isOverflowing[i] && (
                        <MoreBox> {item?.itemlist.join('/ ')}</MoreBox>
                      )}
                    </MenuItem>
                  )
                })}
              </TableMenu>
            </>
          )}
        </>
      )}
    </>
  )
}
export default OptionMenu

const TableMenu = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const MenuTh = styled.li`
  padding: 15px;
  display: grid;
  grid-template-columns: 0.5fr 1.2fr 3fr 1fr 0.7fr;
  align-items: center;
  justify-items: center;
  background-color: #f3f3f3;
  text-align: center;
  color: #8a8a8a;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
`

const MenuItem = styled.li`
  /* min-height: 80px;
  max-height: fit-content; */
  padding: 15px;
  display: grid;
  grid-template-columns: 0.5fr 1.2fr 3fr 1fr 0.7fr;
  /* grid-template-rows: 0.5fr 1.2fr 3fr 1fr 0.7fr; */
  align-items: center;
  justify-items: center;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  color: #000;

  & > :nth-child(6) {
    grid-column: 3 / span 1;
  }

  .menuTitBox {
    width: 100%;
    position: relative;
    line-height: 1.5;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    /* flex-wrap: wrap; */
    /* padding-right: 60px; */
  }
  .moreBtn {
    width: 100%;
    padding-right: 20px;
  }

  .menuTxt {
    width: 100%;
    font-size: 16px;
    color: #000;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* padding-left: 60px; */
  }

  .optionTxt {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.5;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    overflow: hidden;
    word-break: break-all;
  }

  .menuTxt .bold {
    font-weight: 700;
  }

  .menuPrice {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  /* 숨김 처리로 변할시 */
  &.hide {
    opacity: 0.5;
  }
`
const TableHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* align-items: center; */
  margin-bottom: 28px;
  @media ${(props) => props.theme.tablet} {
    display: flex;
    flex-direction: column;
  }

  .tableRight {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 7px;
    margin-top: 40px;
  }

  .sortDropdown {
    width: 165px;
  }
`

const MoreBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.5;
  font-size: 16px;
  margin-top: 20px;
  /* text-align: left; */
  word-break: keep-all;

  /* max-width: auto; */
`
const ArrowBox = styled.p`
  position: absolute;
  top: 0;
  right: 0;
  transition: transform 0.5s ease;
  transform: ${(props) => (props.isActive ? `rotate(180deg)` : `rotate(0deg)`)};
`
